import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";

const SessionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    try {
      responseItem = await axios.get(`/recent-sessions/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content="" onDismiss={toggleActive} />
  ) : null;

  return result ? (
    <Page
      narrowWidth
      backAction={{ onAction: () => navigate("/admin/sessions") }}
      title={`${result?.first_name ? result?.first_name : ""} ${
        result?.last_name ? result?.last_name : ""
      }`}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              CLASS DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text>
                <b>Name</b>
                <br />
                {result?.related_class && result?.related_class?.name
                  ? result?.related_class?.name
                  : "-"}
              </Text>
              <Text>
                <b>Type</b>
                <br />
                {result?.related_class && result?.related_class?.type
                  ? result?.related_class?.type
                  : "-"}
              </Text>
              <Text>
                <b>Parent</b>
                <br />
                {result?.related_class?.parent_type === "element"
                  ? result.related_class?.element?.title
                  : result?.related_class?.parent_type === "studio"
                  ? result.related_class?.studio?.name
                  : result.related_class?.sub_studio?.name}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>Price</b>
                <br />
                {result?.related_class && result?.related_class?.price
                  ? result?.related_class?.price
                  : "-"}
              </Text>
              <Text></Text>
              <Text></Text>
            </FormLayout.Group>

            <Text variant="headingSm" as="h6">
              SESSIONS DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text>
                <b>Instructor</b>
                <br />
                {result?.instructor && result?.instructor?.name
                  ? result?.instructor?.name
                  : "-"}
              </Text>
              <Text>
                <b>Date</b>
                <br />
                {result?.date ? result?.date : "-"}
              </Text>
              {result?.time &&
              Array.isArray(result?.time) &&
              result?.time?.length ? (
                <Text>
                  <b>Available Times</b>
                  <br />
                  {result.time.map((element, index) => {
                    return (
                      <div key={index}>
                        <h3>From time: {element.from_time}</h3>
                        <h3>To time: {element.to_time}</h3>
                      </div>
                    );
                  })}
                </Text>
              ) : (
                <Text>
                  <b>Gender</b>
                  <br />
                  {result?.gender ? result?.gender : "-"}
                </Text>
              )}
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>Total Bookings</b>
                <br />
                {result?.total_bookings_count ?? "-"}
              </Text>
              <Text>
                <b>Internal Bookings</b>
                <br />
                {result?.internal_bookings_count ?? "-"}
              </Text>
              <Text>
                <b>External Bookings</b>
                <br />
                {result?.external_bookings_count ?? "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>Total Capacity</b>
                <br />
                {result?.total_capacity ?? "-"}
              </Text>
              <Text>
                <b>Total Capacity Left</b>
                <br />
                {result?.total_capacity_left ?? "-"}
              </Text>
              <Text>
                <b>External Capacity</b>
                <br />
                {result?.external_capacity ?? "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>External Capacity Left</b>
                <br />
                {result?.external_capacity_left ?? "-"}
              </Text>
              <Text>
                <b>Internal Capacity</b>
                <br />
                {result?.capacity ?? "-"}
              </Text>
              <Text>
                <b>Internal Capacity Left</b>
                <br />
                {result?.internal_capacity_left ?? "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
      </FormLayout>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default SessionDetails;
